import Constants from 'expo-constants';

export const API_BASE_URL: string | undefined = Constants?.manifest?.extra?.API_BASE_URL;
export const GOOGLE_MAPS_API_KEY: string | undefined = Constants?.manifest?.extra?.GOOGLE_MAPS_API_KEY
export const WP_SITE_URL: string = Constants?.manifest?.extra?.WP_SITE_URL
